import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import { Container, Stage } from '@inlet/react-pixi';
import NFTRow1 from '../../assets/images/NFT-Row1.png';
import NFTRow2 from '../../assets/images/NFT-Row2.png';
import Image from '../elements/Image';
import ScrollingImage from '../elements/ScrollingImage.js';
import ManifestoBackground from '../../assets/images/Manifesto_Background.jpg';
import { Link } from 'react-router-dom';
import {SimpleGrid, Text, Heading, Box, Image as CImage } from '@chakra-ui/react';
import TreasureChest from '../../assets/images/TreasureChest.png';
import Armor from '../../assets/images/Armor.png';
import Map from '../../assets/images/Map.png';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Manifesto = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    'section center-content',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'section-inner'
  );

  /*
  useEffect(() => {
    const handleResize = () => {
      if(window.innerWidth/window.innerHeight > 768){
        setslidingNFTSHeight(window.innerHeight);
      }
      else if(window.innerWidth/window.innerHeight > 600){
        setslidingNFTSHeight(window.innerHeight * 1.5);
      }
      else if(window.innerWidth/window.innerHeight > 400){
        setslidingNFTSHeight(window.innerHeight * 1.75);
      }
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  });
  */

  return (
        <section
        {...props}
        className={outerClasses}
      >

        <Image className='backgroundStudent1'
            src={require('../../assets/images/Andrew.png')}
            width={700}
            height={900} />

        <Image className='backgroundStudent2'
          src={require('../../assets/images/Developer1.png')}
          width={700}
          height={900} />
        <div className='container-sm'>
          <div className={innerClasses}>
            {/* Old Manifesto
            
            <div className='manifesto-text-container'>
              <h1 className='mt-0 mb-16 reveal-from-bottom section-header-title' data-reveal-delay='200'>
                MANIFESTO
              </h1>
              
              <div className='container-xs'>
                <p className='m-0 mb-32 reveal-from-bottom manifesto-text' data-reveal-delay='400'>
                  Welcome to EduVerse: the universe where the dream of world education has become a reality. Children running free, books that grow on trees, and a safe and magical school guarded by the fairies of the forest. A utopia that knows no boundaries of race, language, nor gender. Join our journey as we transform our virtual and physical worlds into the utopia of the future.
                </p>
                <Link to='/mint'>
                  <div className='button button-primary button-wide-mobile button-sm'>
                    MINT NOW
                  </div>
                </Link>
              </div>
            </div>

            */}

            <div className='manifesto-text-container'>
              <h1 className='mt-0 mb-16 reveal-from-bottom section-header-title' data-reveal-delay='200'>
                About EduVerse
              </h1>
              <h1 className='mt-0 mb-16 reveal-from-bottom section-header-title' data-reveal-delay='200'>
                Where Gaming Meets Charity
              </h1>
              <div>
                <p className='m-0 mb-32 reveal-from-bottom manifesto-text' data-reveal-delay='400'>
                  EduVerse is a platform that bridges the gap between traditional charities and the younger generation through innovative fundraising opportunities. Our micro-transaction-based gaming system democratizes philanthropy, allowing the general public to contribute to social causes through an engaging gaming experience while providing the user opportunities to earn money through a revenue share system.
                </p>
              </div>
            </div>

            <SimpleGrid className='features-grid' columns={3} minChildWidth='300px' maxWidth={window.innerWidth} placeItems='center' gridAutoFlow='column' gridTemplateColumns={{sm:'100% 100% 100%', md:'33% 34% 33%'}} overflow='scroll' scrollSnapType='x mandatory'>
              <Box bg='white' height='600px' width='95%' display='flex' flexDirection='column'>
                <Heading size='md' color='black' m={5}>Build Your Hero</Heading>
                <CImage src={Armor} boxSize='300px'/>
                <Box marginTop='auto' marginBottom='auto'>
                  <Text fontSize={{base: 'sm', lg:'md'}} textAlign='center' mx={1}>
                    Level up your student and gain access to powerful abilities to destroy any competition.
                  </Text>
                </Box>
              </Box>

              <Box bg='white' height='600px' width='95%' display='flex' flexDirection='column'>
                <Heading size='md' color='black' m={5}>Explore & Collect Loot</Heading>
                <CImage src={Map} boxSize='300px'/>
                <Box marginTop='auto' marginBottom='auto'>
                  <Text fontSize={{base: 'sm', lg:'md'}} textAlign='center' mx={1}>
                    Discover a universe with countless activities to do, and outfit your student with a vast array of cosmetic items and equipment. 
                  </Text>
                </Box>
              </Box>

              <Box bg='white' height='600px' width='95%' display='flex' flexDirection='column'>
                <Heading size='md' color='black' m={5}>Real Life Prizes</Heading>
                <CImage src={TreasureChest} boxSize='300px'/>
                <Box marginTop='auto' marginBottom='auto'>
                  <Text fontSize={{base: 'sm', lg:'md'}} textAlign='center' mx={1}>
                    Exchange your tokens for an array of real life prizes.
                  </Text>
                </Box>
              </Box>                  
            </SimpleGrid>              

            <Box>
              <Link to='/mint'>
                <div className='button button-primary button-wide-mobile button-sm mint-button'>
                  Learn More
                </div>
              </Link>
            </Box>
            
          </div>
        </div>
        {/* Create a transparent image the size of stage so canvas can accept touch input */}
        <img src={ManifestoBackground} width={window.innerWidth} height={400} alt='' className='manifesto-background'/>

        <Stage width={window.innerWidth} height={400} options={{ backgroundAlpha: 0 }}>
          <Container>
            <ScrollingImage tileImage={NFTRow1} goRight={true} x={0} y={0} width={window.innerWidth * 2} height={400} scale={0.5} xDelta={2} alpha={1}/>
            <ScrollingImage tileImage={NFTRow2} goRight={false} x={0} y={200} width={window.innerWidth * 2} height={400} scale={0.5} xDelta={2} alpha={1}/>
          </Container>
        </Stage>
      </section>
      
  );
}

Manifesto.propTypes = propTypes;
Manifesto.defaultProps = defaultProps;

export default Manifesto;